import React from 'react'
import { useState } from 'react'

export default function AddTodo(props) {

    const [Title, setTitle] = useState('');
    const [Desc, setDesc] = useState('');
    const HandelSubmit = (e) => {
        e.preventDefault();
        if (!Title || !Desc) {
            alert('Title Or Description Cannot Be Empty')
        }

        else {
            props.AddTodoFunc(Title, Desc);
            setTitle('');
            setDesc('');
        }
    }

    return (

        <div className="min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 ">
            <div className={`max-w-md w-full space-y-8 ${props.theme == "dark" ? 'bg-gray-800 ' : 'bg-gray-100'} p-10 rounded-xl`}>
                <div>
                    <h2 className="mt-6 text-center text-3xl font-extrabold ">Add Todo</h2>
                </div>
                <form className="mt-8 space-y-6" onSubmit={HandelSubmit}>
                    <input type="hidden" name="remember" value="true" />
                    <div className="rounded-md shadow-sm -space-y-px">
                        <div>
                            <label htmlFor="email-address" className="sr-only">Title</label>
                            <input value={Title} onChange={(e) => { setTitle(e.target.value) }} id="email-address" name="email" type="text" autoComplete='title' className="appearance-none rounded-none relative block w-full px-3 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm mb-2" placeholder="Title" />
                        </div>
                        <div>
                            <label htmlFor="password" className="sr-only">Description</label>
                            <input value={Desc} onChange={(e) => { setDesc(e.target.value) }} id="password" name="password" type="text" autoComplete='desc' className="appearance-none rounded-none relative block w-full px-3 py-4 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm" placeholder="Description" />
                        </div>
                    </div>

                    <div>
                        <button type="submit" className={`group relative w-full flex justify-center py-2 px-4 border border-transparent text-lg font-medium rounded-md  ${props.theme === "light" ? "bg-gray-300 hover:bg-gray-200 text-black" : "bg-gray-900 hover:bg-gray-700 text-white"} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}>
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>

    )
}
